// extracted by mini-css-extract-plugin
export var active = "ModalHeader-module--active--a5371";
export var closeButton = "ModalHeader-module--closeButton--458e2";
export var fadeInAnimation = "ModalHeader-module--fadeInAnimation--8a6c4";
export var modalHeader = "ModalHeader-module--modalHeader--6d05a";
export var navigation = "ModalHeader-module--navigation--13761";
export var prevArrow = "ModalHeader-module--prevArrow--86bdc";
export var stepLine = "ModalHeader-module--stepLine--bb8b7";
export var stepLines = "ModalHeader-module--stepLines--3ff1e";
export var text = "ModalHeader-module--text--71c8a";